import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { StepService } from '../../services/step.service';

@Component({
  selector: 'app-unidad-detail-modal',
  templateUrl: './unidad-detail-modal.component.html',
  styleUrls: ['./unidad-detail-modal.component.scss']
})
export class UnidadDetailModalComponent implements OnInit {


  summary: any = {
    carTitle: '---',
    carModel: '---',
    carImage: './assets/img/auto_no_disponible.svg',
    state: '---',
    priceWithIva: '0',
    refund: '0',
    concept: '---',
    period: '---',
    initialPayment: '0',
    monthlyPayment: '0',
    insurance: '---',
  };

  details = [
    {
      desc: 'Color interior',
      value: 'Negro'
    },
    {
      desc: 'Color exterior',
      value: 'Rojo'
    },
    {
      desc: 'Transmisión',
      value: 'Manual'
    },
    {
      desc: 'Tipo de combustible',
      value: 'Premium'
    },
  ]

  formatter = new Intl.NumberFormat('es-MX');
  templateSuffix = environment.templateSuffix;

  constructor(
    private stepService: StepService,
    private matRef: MatDialogRef<UnidadDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.summary = this.data.summary;
    this.details = this.data.details;
  }

  save(){
    this.matRef.close(true);
  }


}
